/* ADG live preview — integration layer. Fully self-contained: builds the shell,
 * injects the hero card into the banner, and mirrors the picker's saved state
 * into the preview(s). Touches NO existing theme file — the picker is observed
 * only through the localStorage it already writes.
 *
 * Remove the whole feature by deleting adg-preview* and the single
 * {% render 'adg-live-preview' %} line. Nothing else changes.
 */
(function () {
  "use strict";
  var cfgEl = document.querySelector("script[data-adg-preview-config]");
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.product) return;

  // The picker stores a 400px thumb (`image`) + the raw featured src (`image_full`).
  // Request a properly-sized render so the popup isn't a stretched thumbnail.
  function sized(src, w) {
    if (!src) return null;
    // Shopify CDN images accept the _WxH size suffix. Artwork-index images
    // (CloudFront /art/...) do NOT — suffixing 403s them. They're already
    // print-res (1024), so pass them through untouched.
    if (!/cdn\.shopify\.com/.test(src)) return src;
    return src.replace(/(\.(?:jpg|jpeg|png|webp))(\?[^"']*)?$/i, "_" + w + "x" + w + "$1$2");
  }
  function urlsFromPicks(picks) {
    return (picks || []).map(function (p) { return p ? sized(p.image_full || p.image, 1200) : null; });
  }
  function readPicks() {
    try {
      var stored = JSON.parse(localStorage.getItem(cfg.storageKey) || "null");
      return stored && stored.picks ? stored.picks : null;
    } catch (e) { return null; }
  }
  function sync() {
    var slots = JSON.stringify(urlsFromPicks(readPicks()));
    document.querySelectorAll("adg-product-preview[data-byo]").forEach(function (el) {
      if (el.getAttribute("slots") !== slots) el.setAttribute("slots", slots);
    });
    paintPreviewButtons();
  }
  // The theme's Preview button lights up in the ADG action color the moment the set
  // holds at least one pick (incl. picks restored from localStorage) — a clear
  // "you have something to preview" cue. The color rule lives in adg-preview.css.
  function paintPreviewButtons() {
    var picks = readPicks();
    var on = !!(picks && picks.some(Boolean));
    document.querySelectorAll("[data-byo-preview]").forEach(function (b) {
      b.classList.toggle("adg-has-picks", on);
    });
  }

  // Catch the picker's saves without touching its code: it calls
  // localStorage.setItem on every mutation; we wrap that, filtered to our key.
  //
  // THE WRAP GOES ON THE PROTOTYPE, NOT THE INSTANCE. A Storage object treats
  // property assignment as STORING A VALUE, so in WebKit
  // `localStorage.setItem = fn` does not replace the method at all — it writes
  // the stringified function under the key "setItem" and leaves the real method
  // in place. Measured side by side (2026-08-16): the instance patch fires in
  // Chromium and never fires in Safari. That is why the live preview sat on its
  // "Select an image" placeholder in Safari however many designs were picked
  // (Justin: "the images aren't appearing in the preview window"). The storage
  // event is no safety net either — it only fires in OTHER tabs, never the one
  // doing the writing.
  //
  // One wrap for the page, with a list of listeners, because the dock and the
  // popup each run this file and a "wrap once" guard would otherwise leave the
  // second one deaf.
  window.__adgStorageHooks = window.__adgStorageHooks || [];
  window.__adgStorageHooks.push(function (key) {
    if (key === cfg.storageKey) { try { sync(); } catch (e) {} }
  });
  try {
    var SProto = Object.getPrototypeOf(localStorage) || window.Storage.prototype;
    var _rmReal = SProto.removeItem;
    if (!SProto.__adgWrapped) {
      var _setReal = SProto.setItem;
      function fire(store, key) {
        if (store !== window.localStorage) return;   // sessionStorage shares this prototype
        var hooks = window.__adgStorageHooks || [];
        for (var i = 0; i < hooks.length; i++) { try { hooks[i](key); } catch (e) {} }
      }
      SProto.setItem = function (k, v) { var r = _setReal.apply(this, arguments); fire(this, k); return r; };
      SProto.removeItem = function (k) { var r = _rmReal.apply(this, arguments); fire(this, k); return r; };
      SProto.__adgWrapped = true;
    }
    // Sweep up what the old instance assignment left behind: Safari stored the
    // two functions as ordinary values under these keys.
    if (localStorage.getItem('setItem') != null) _rmReal.call(localStorage, 'setItem');
    if (localStorage.getItem('removeItem') != null) _rmReal.call(localStorage, 'removeItem');
  } catch (e) { /* restricted env — initial sync + storage event still cover it */ }
  window.addEventListener("storage", function (e) { if (e.key === cfg.storageKey) sync(); });

  function initialSlots() {
    // start in PICKER mode from the first paint (no catalog-reel flash): current
    // picks if any, else an all-empty array -> the single "Select an image" placeholder
    var picks = readPicks();
    if (picks && picks.length) return JSON.stringify(urlsFromPicks(picks));
    var n = cfg.slotCount || (cfg.kind === "calendar" ? 12 : 8);
    return JSON.stringify(new Array(n).fill(null));
  }
  function makePreview(extra) {
    var el = document.createElement("adg-product-preview");
    el.setAttribute("product", cfg.product);
    el.setAttribute("assets-base", "/");
    el.setAttribute("asset-map", JSON.stringify(cfg.assetMap || {}));
    el.setAttribute("arts", JSON.stringify(cfg.arts || []));
    el.setAttribute("slots", initialSlots());          // BYO picker mode from the start
    if (cfg.placeholderLabel) el.setAttribute("placeholder-label", cfg.placeholderLabel);
    el.setAttribute("data-byo", "");
    el.id = "adg-byo-preview";
    if (cfg.label) el.setAttribute("label", cfg.label);
    for (var k in (extra || {})) el.setAttribute(k, extra[k]);
    return el;
  }

  // Map a filled tray slot to its position in the preview. Calendar shows all 12
  // fixed months (position = month index); cards stack only the picks (position =
  // ordinal among filled slots). Returns null if it can't be determined.
  function slotFocusIndex(slot) {
    if (cfg.kind === "calendar") {
      var m = parseInt(slot.getAttribute("data-byo-slot"), 10);
      return isNaN(m) ? null : m - 1;
    }
    var box = (slot.closest && slot.closest("[data-byo-slots]")) || slot.parentNode;
    if (!box) return null;
    var filled = box.querySelectorAll(".byo-slot--filled");
    for (var i = 0; i < filled.length; i++) if (filled[i] === slot) return i;
    return null;
  }

  function build() {
    var shell = document.querySelector("adg-preview-shell");
    if (!shell) { shell = document.createElement("adg-preview-shell"); document.body.appendChild(shell); }

    // Banner embed is OFF (cfg.bannerEmbed=false). Instead the preview is a dormant
    // source (holds state, renders nothing) that the Preview button / dock use — and
    // on tablet-and-up it DOCKS ON LOAD so it's visibly waiting (showing the
    // placeholder) and fills in as picks are added. Phones stay popup-only.
    var hero = cfg.bannerEmbed && cfg.kind !== "calendar" ? document.querySelector(".byo-builder__hero") : null;
    if (hero) {
      var pv = makePreview({ "no-interact": "", auto: "", "auto-dock": "", "fronts-only": "" });
      var wrap = document.createElement("div");
      wrap.className = "adg-live-hero";
      wrap.appendChild(pv);
      var overlay = hero.querySelector(".byo-builder__hero-overlay");
      if (overlay) hero.insertBefore(wrap, overlay); else hero.appendChild(wrap);
    } else {
      var src = makePreview({ dormant: "" });
      document.body.appendChild(src);
      sync();  // reflect any saved picks into the source before docking
      // DOCK ON EVERY SCREEN, phones included. This used to be gated to
      // >=700px, so an iPhone got no preview drawn on the page at all — the
      // only way to reach it was the Preview button, and if you did not know
      // that, the feature simply looked dead. That is exactly what happened:
      // "none of the previews work, the animated previews are blank" (Justin,
      // 08-16, from his iPhone). Nothing was broken; there was nothing to see.
      // A docked card does cost real estate on a small screen, which is why it
      // was gated — the shell already renders it as a compact mini card, so
      // the trade is a strip at the edge versus a feature nobody finds.
      requestAnimationFrame(function () { shell.dock(src); });
    }

    sync(); // initial paint from whatever's already saved

    // the picker may mount its Preview button after us — paint it the moment it
    // appears (one-shot), then live pick changes repaint through sync().
    if (!document.querySelector("[data-byo-preview]")) {
      var moBtn = new MutationObserver(function () {
        if (document.querySelector("[data-byo-preview]")) { paintPreviewButtons(); moBtn.disconnect(); }
      });
      moBtn.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { moBtn.disconnect(); }, 8000);
    }

    // Preview button -> full-screen popup. Capture phase so the old modal
    // handler never fires. (Clicking the hero opens via the shell's own listener.)
    document.addEventListener("click", function (e) {
      var btn = e.target.closest && e.target.closest("[data-byo-preview]");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var shell = document.querySelector("adg-preview-shell");
      var src = document.getElementById("adg-byo-preview");
      if (shell && src) shell.open(src);
    }, true);

    // Tapping a FILLED tray slot (a picked image pinned up top) opens the popup
    // viewer focused on that item. A native drag never fires 'click', so this
    // leaves the calendar's drag-to-reorder untouched; the × remove button and
    // empty slots are excluded.
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var slot = e.target.closest(".byo-slot--filled");
      if (!slot || e.target.closest(".byo-slot__remove")) return;
      var shell = document.querySelector("adg-preview-shell");
      var src = document.getElementById("adg-byo-preview");
      if (!shell || !src) return;
      var pos = slotFocusIndex(slot);
      if (pos != null) shell._pos = pos;    // seed the popup to the tapped item
      shell.open(src);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", build);
  else build();
})();
